import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';
import { getDisplayDate } from 'utils/date';

import './content-card-stats-header.scss';

import type {
  ContentCardContentType
} from 'components/cards/content-card/types';

applyTranslations(require('components/cards/content-card/shared/content-card-shared.i18n.json'));

type Props = {
  type: ContentCardContentType,
  date: string
};

const SHARED_MSG_KEY = 'content_card_shared';

const ContentCardStatsHeader = ({
  type,
  date
}: Props): JSX.Element => (
  <div className="content-card-stats-header">
    {__t(`${SHARED_MSG_KEY}.labels.${type}_capitalized`)}
    &nbsp;{__t(`${SHARED_MSG_KEY}.labels.published`)}
    &nbsp;{getDisplayDate(date)}
  </div>
);

export default ContentCardStatsHeader;
